
const services = [
  {
    id: 1,
    icon: 'ri-hotel-line',
    title: 'Budget Family Hotels',
    description: 'Hand-picked affordable hotels near halal restaurants and mosques. Spacious rooms perfect for families, with excellent transport links across London.',
    link: '#hotels',
  },
  {
    id: 2,
    icon: 'ri-home-heart-line',
    title: 'Halal-Friendly Accommodations',
    description: 'Carefully selected stays with halal dining options nearby, prayer facilities access, and culturally sensitive service for Muslim families.',
    link: '#accommodations',
  },
  {
    id: 3,
    icon: 'ri-taxi-line',
    title: 'Airport Transfers',
    description: 'Reliable private transfers from Heathrow, Gatwick, Stansted, and Luton airports. Meet and greet service with family-friendly vehicles.',
    link: '#transfers',
  },
  {
    id: 4,
    icon: 'ri-briefcase-4-line',
    title: 'Business Trip Services',
    description: 'Professional arrangements for business travelers including corporate hotels, meeting room bookings, and executive transport services.',
    link: '#business',
  },
  {
    id: 5,
    icon: 'ri-presentation-line',
    title: 'Seminars & Conferences',
    description: 'Complete event planning support for seminars, conferences, and corporate gatherings. Venue sourcing, catering, and logistics management.',
    link: '#seminars',
  },
  {
    id: 6,
    icon: 'ri-map-pin-user-line',
    title: 'Guided City Tours',
    description: 'Customised London tours covering iconic landmarks, hidden gems, and cultural sites. Private guides available in Urdu and English.',
    link: '#tours',
  },
];

export default function ServicesGrid() {
  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-2 bg-[#C9A961]/10 text-[#C9A961] text-sm font-medium rounded-full mb-4">
            Our Services
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-[#1A1F2E] mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
            Everything You Need for Your London Visit
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Comprehensive travel services tailored for overseas Pakistani families visiting the UK
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => (
            <div
              key={service.id}
              className="group bg-white border border-gray-100 rounded-2xl p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-2 cursor-pointer"
            >
              <div className="w-16 h-16 bg-[#FFF8E7] rounded-2xl flex items-center justify-center mb-6 group-hover:bg-[#C9A961] transition-colors">
                <i className={`${service.icon} text-2xl text-[#C9A961] group-hover:text-white transition-colors`}></i>
              </div>
              <h3 className="text-xl font-bold text-[#1A1F2E] mb-4">{service.title}</h3>
              <p className="text-gray-600 mb-6 leading-relaxed">{service.description}</p>
              <a href={service.link} className="inline-flex items-center gap-2 text-[#C9A961] font-medium hover:gap-3 transition-all cursor-pointer">
                Learn More
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
